
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...catchAll]",
      function () {
        return require("private-next-pages/[...catchAll].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...catchAll]"])
      });
    }
  